import {
    createSimulatedVehicleFromRestV1,
    simulatedVehicleStatusFromRestV1,
} from 'domain/mappers/simulatedVehicleFromRestV1';
import type { CreateSimulatedVehicleResponseFE, SimulatedVehicleStatusFE } from 'domain/vehicle';
import { setHeaders } from 'features/simulations/utils';

export interface CreateSimulatedVehicleRequest {
    vin: string;
    name: string;
    normalizedName: string;
    environment: string;
    hocImageTag: string;
    hermodImageTag: string;
}

export type CreateSimulatedVehicleResponse = CreateSimulatedVehicleResponseFE;

export type SimulatedVehicleStatus = SimulatedVehicleStatusFE;

const endpoint = import.meta.env.VITE_SIMULATED_VEHICLES_ENDPOINT;

export const createSimulatedVehicle = async (
    request: CreateSimulatedVehicleRequest
): Promise<CreateSimulatedVehicleResponse> => {
    const response = await fetch(`${endpoint}/simulated-vehicles/api/v1/vehicles`, {
        method: 'POST',
        headers: {
            ...(await setHeaders()),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
    });

    if (!response.ok) {
        const error = new Error(`Failed to create simulated vehicle: ${response.status}`) as Error & {
            status?: number;
        };
        error.status = response.status;
        throw error;
    }

    return createSimulatedVehicleFromRestV1(await response.json());
};

export const getSimulatedVehicleStatus = async (vehicleId: string): Promise<SimulatedVehicleStatus> => {
    const response = await fetch(`${endpoint}/simulated-vehicles/api/v1/vehicles/${encodeURIComponent(vehicleId)}`, {
        headers: await setHeaders(),
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch simulated vehicle status: ${response.status}`);
    }

    return simulatedVehicleStatusFromRestV1(await response.json());
};
